import script from "./CourseList.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./CourseList.vue?vue&type=style&index=1&id=cb52333e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb52333e"]])

export default __exports__